<template>
  <img v-if="resolvedSrc || resolvedSrcset"
    :src="crossOriginSrc(resolvedSrc)"
    :srcset="resolvedSrcset ? crossOriginSRCSET(resolvedSrcset) : undefined"
    :sizes="sizes || undefined"
    :alt="alt"
    :class="loaded ? 'show' : 'hide'"
    @load="loaded = true" />
</template>

<script setup>
import { ref, computed } from 'vue'
import { imageById, yamlFirst, crossOriginSrc, crossOriginSRCSET } from '../helpers.js'

const props = defineProps({
  src: { type: String, default: '' },
  srcset: { type: String, default: '' },
  sizes: { type: String, default: '' },
  alt: { type: String, default: '' },
  id: { type: String, default: '' },
  images: { type: Array, default: () => [] },
});

const imageObject = computed(() =>
  props.id && props.images?.length ? imageById(props.images, yamlFirst(props.id)) : null
);

const resolvedSrc = computed(() => props.src || imageObject.value?.url || '');
const resolvedSrcset = computed(() => props.srcset || imageObject.value?.srcset || '');

const loaded = ref(false);
setTimeout(() => loaded.value = true, 300);
</script>

<style scoped>
img {
  transition: opacity 0.3s ease-in-out;
}

img.show {
  opacity: 1;
}

img.hide {
  opacity: 0;
}
</style>
